import { createIcon } from "@chakra-ui/icons";

// Created from Vector.svg

export const MapIcon = createIcon({
  displayName: "Map",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        id="Vector"
        d="M1 6V22L8 18L16 22L23 18V2L16 6L8 2L1 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        id="Vector_2"
        d="M8 2V18"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        id="Vector_3"
        d="M16 6V22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>
  ),
});
